import type { ListingsAPISponsoredContext } from './types/ListingsAPISponsoredContext';

/** The request headers listings-api reads the ad context from. */
export const toSponsoredHeaders = (
  context: ListingsAPISponsoredContext,
): Record<string, string> => ({
  'noths-ads-page-id': String(context.pageId),
  ...(context.categoryId !== undefined && { 'noths-ads-category-id': context.categoryId }),
  ...(context.keywords !== undefined && { 'noths-ads-keywords': context.keywords }),
  'noths-ads-batch': String(context.batch),
  'noths-ads-user-id': context.userId,
  'noths-ads-user-consent': String(context.userConsent),
  ...(context.shownProductCodes.length > 0 && {
    'noths-ads-shown': context.shownProductCodes.join(','),
  }),
  ...(context.ipAddress && { 'ip-address': context.ipAddress }),
  ...(context.userAgent && { 'user-agent': context.userAgent }),
});
